import { Button } from '@britishcouncil/react-admin';
import { useBlocker } from 'react-router';
import { Modal, ModalActions, ModalContent, ModalHeader } from 'semantic-ui-react';
import { ROUTING_PATHS } from 'const';

interface UnsavedChangesModalProps {
  isModified: boolean;
}

export const UnsavedChangesModal = ({ isModified }: UnsavedChangesModalProps) => {
  const blocker = useBlocker(({ nextLocation }) => {
    return isModified && nextLocation.pathname !== ROUTING_PATHS.examDatesForLocations.absolutePath;
  });

  return (
    <Modal open={blocker.state === 'blocked'} size="small">
      <ModalHeader>Unsaved changes</ModalHeader>
      <ModalContent>
        <div>You have unsaved exam date changes.</div>
        <div>Would you like to discard changes or continue editing?</div>
      </ModalContent>
      <ModalActions>
        <Button secondary onClick={blocker.proceed}>
          Discard changes
        </Button>
        <Button primary onClick={blocker.reset}>
          Continue editing
        </Button>
      </ModalActions>
    </Modal>
  );
};
